// Operator action trail — mirrors OperatorAuditService / GET /operator/audit.
import { z } from "zod";
import { operatorFetch } from "./client";

export interface OperatorAuditEntry {
  id: string;
  operatorId: string;
  /** Acting operator's email (joined; null if the operator row is gone). */
  operatorEmail: string | null;
  action: string;
  orgId: string | null;
  detail: Record<string, unknown>;
  createdAt: string;
}

const entrySchema = z.object({
  id: z.string(),
  operatorId: z.string(),
  operatorEmail: z.string().nullable(),
  action: z.string(),
  orgId: z.string().nullable(),
  detail: z.record(z.string(), z.unknown()),
  createdAt: z.string(),
}) satisfies z.ZodType<OperatorAuditEntry>;

const responseSchema = z.object({ entries: z.array(entrySchema) });

export function listOperatorAudit(opts: { orgId?: string; limit?: number } = {}, signal?: AbortSignal): Promise<OperatorAuditEntry[]> {
  const p = new URLSearchParams();
  if (opts.orgId) p.set("orgId", opts.orgId);
  if (opts.limit) p.set("limit", String(opts.limit));
  const qs = p.toString();
  return operatorFetch(`/operator/audit${qs ? `?${qs}` : ""}`, { signal, schema: responseSchema }).then((r) => r.entries);
}
